import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
    selector: 'cm-loader',
    templateUrl: './cm-loader.component.html',
    styleUrls: ['./cm-loader.component.scss'],
    standalone: false
})
export class CmLoaderComponent implements OnInit {
	@Input() loading$: Observable<boolean>;

	constructor() {}

	ngOnInit() {}
}
